export default "__VITE_ASSET__aac23f4e__"